export default {
  waiting: false,
  el: null,
  container: null,
  init(el){
    this.el = el;
    var container = jQuery('body > .page');
    if(!container.length) return;
    this.container = container[0];
    //window.addEventListener('scroll', this.onScroll.bind(this)) // переносим поиск в top fixed и корзину
  },
  onScroll: function (e) {
    if (!this.waiting) {
      this.checkStickState(e);
      this.waiting = true;
      setTimeout((function () {
        this.waiting = false;
      }).bind(this), 50);
    }
  },
  checkStickState(e){
    var stickyState = window.scrollY > 50;
    jQuery(this.container).toggleClass('sticky-state', stickyState);
  }
};
